import { EditorTools } from '@progress/kendo-react-editor';

const CustomFontNameToolSettings = {
  style: 'font-family',
  defaultItem: {
    text: 'Font family',
    value: 'open-sans-regular, "Helvetica", sans-serif'
  },
  items: [
    {
      text: 'Open Sans',
      value: 'open-sans-regular, "Helvetica", sans-serif'
    }, {
      text: 'Montserrat',
      value: 'montserrat-regular, "Helvetica", sans-serif'
    }, {
      text: 'Arial',
      value: 'Arial, "Helvetica", sans-serif'
    }, {
      text: 'Tahoma',
      value: 'Tahoma, Geneva, sans-serif'
    }, {
      text: 'Courier New',
      value: 'Courier New, Courier, monospace'
    }, {
      text: 'Times New Roman',
      value: 'Times New Roman, Times, serif'
    }
  ]
};

const FontNameTool = EditorTools.createStyleDropDownList(CustomFontNameToolSettings);

export default FontNameTool;
